import React from 'react';

import { colors, styled } from 'core/styles';
import { Rating, ratingToLetter } from 'domain/types';
import { Either } from 'utils/either';

import { AreaSize } from '../types';

export function RatingLabel({ size, rating }: { size: AreaSize; rating: Either<Rating> }) {
  return rating ? (
    <Root>
      {(size === 'large' || size === 'extra-large') && 'Rating: '}
      {rating.fold(
        r => ratingToLetter(r),
        () => '-',
      )}
    </Root>
  ) : null;
}

const Root = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minWidth: 24,
  height: '100%',
  padding: '0px 7px',
  borderRadius: '100px',
  background: colors.blackOpacity[8],
});
